import { render, staticRenderFns } from "./MessageMatchedConfig.vue?vue&type=template&id=4bc8aaf2&scoped=true"
import script from "./MessageMatchedConfig.vue?vue&type=script&lang=js"
export * from "./MessageMatchedConfig.vue?vue&type=script&lang=js"
import style0 from "./MessageMatchedConfig.vue?vue&type=style&index=0&id=4bc8aaf2&prod&lang=scss&scoped=true"
import style1 from "./MessageMatchedConfig.vue?vue&type=style&index=1&id=4bc8aaf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc8aaf2",
  null
  
)

export default component.exports